import {
  ADFORM_PREBID_BIDDER,
  RTBHOUSE_PREBID_BIDDER,
  TABOOLA_PREBID_BIDDER,
  TURK_TELEKOM_PREBID_BIDDER,
  YANDEX_PREBID_BIDDER,
  INDEX_EXCHANGE_BIDDER,
  PUBMATIC_PREBID_BIDDER,
  THEADX_PREBID_BIDDER,
  ADMATIC_PREBID_BIDDER,
  ESKIMI_PREBID_BIDDER,
} from '../bidders';

export const categoryAdUnits = {
  desktop: {
    kategoriTop: {
      name: 'Onedio.com_Desktop_KategoriSayfaİçi_Top',
      sizes: [[728, 90], 'fluid'],
      collapse: false,
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666436),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_category_top'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508962),
          THEADX_PREBID_BIDDER(757),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Category_Inlist_Top',
          sizes: ['fluid', [728, 90]],
        },
      },
    },
    kategoriMiddle1: {
      name: 'Onedio.com_Desktop_KategoriSayfaİçi_Middle1',
      sizes: [[728, 90], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666436),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_category_mid_1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508962),
          THEADX_PREBID_BIDDER(757),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Category_Inlist_Middle',
          sizes: ['fluid', [728, 90]],
        },
      },
    },
    kategoriMiddle2: {
      name: 'Onedio.com_Desktop_KategoriSayfaİçi_Middle2',
      sizes: [[728, 90], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666436),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_category_mid_2'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508962),
          THEADX_PREBID_BIDDER(757),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Category_Inlist_Middle',
          sizes: ['fluid', [728, 90]],
        },
      },
    },
    kategoriYaniTop: {
      name: 'Onedio.com_Desktop_KategoriYanı_Top',
      sizes: [[300, 250], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666435),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_category_sidebar_1'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508959),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      collapse: false,
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Category_Sidebar_Top',
          sizes: [[250, 250], [300, 250], [336, 280], 'fluid', [200, 200]],
        },
      },
    },
    kategoriYaniBottom: {
      name: 'Onedio.com_Desktop_KategoriYanı_Bottom',
      sizes: [[160, 600], [300, 600], [336, 280], [300, 250], [120, 600], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1666438),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-1'),
          TABOOLA_PREBID_BIDDER('d_category_sidebar_2'),
          INDEX_EXCHANGE_BIDDER(1042157),
          PUBMATIC_PREBID_BIDDER(5508961),
          THEADX_PREBID_BIDDER(738),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Desktop_Category_Sidebar_Bottom',
          sizes: [[300, 600], 'fluid', [200, 200], [250, 250], [300, 250], [336, 280]],
        },
      },
    },
    kategoriSponTop: {
      name: 'Onedio.com_Desktop_Sponsored_KategoriListeArası_Top',
      sizes: [[728, 90], 'fluid'],
    },
    kategoriSponMiddle: {
      name: 'Onedio.com_Desktop_Sponsored_KategoriListeArası_Middle',
      sizes: [[728, 90], 'fluid'],
    },
    kategoriSponBottom: {
      name: 'Onedio.com_Desktop_Sponsored_KategoriListeArası_Bottom',
      sizes: [[728, 90], 'fluid'],
    },
  },
  mobile: {
    kategoriTop: {
      name: 'Onedio.com_Mobile_KategoriSayfaİçi_Top',
      sizes: [[336, 280], [300, 250], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_category_top'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508962),
          THEADX_PREBID_BIDDER(756),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Category_Inlist_Top',
          sizes: [[250, 250], [336, 280], [300, 250], 'fluid', [200, 200], [320, 480]],
        },
      },
    },
    kategoriMiddle1: {
      name: 'Onedio.com_Mobile_KategoriSayfaİçi_Middle1',
      sizes: [[336, 280], [300, 250], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_category_mid_1'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508962),
          THEADX_PREBID_BIDDER(756),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Category_Inlist_Middle',
          sizes: [[250, 250], [336, 280], [300, 250], 'fluid', [200, 200], [320, 480]],
        },
      },
    },
    kategoriMiddle2: {
      name: 'Onedio.com_Mobile_KategoriSayfaİçi_Middle2',
      sizes: [[336, 280], [300, 250], 'fluid'],
      prebid: {
        bids: [
          ADFORM_PREBID_BIDDER(1674488),
          RTBHOUSE_PREBID_BIDDER,
          TURK_TELEKOM_PREBID_BIDDER,
          YANDEX_PREBID_BIDDER('R-A-3025919-2'),
          TABOOLA_PREBID_BIDDER('m_category_mid_2'),
          INDEX_EXCHANGE_BIDDER(1042153),
          PUBMATIC_PREBID_BIDDER(5508962),
          THEADX_PREBID_BIDDER(756),
          ADMATIC_PREBID_BIDDER,
          ESKIMI_PREBID_BIDDER,
        ],
      },
      i18n: {
        en: {
          name: 'Onedio.co_Mobile_Category_Inlist_Middle',
          sizes: [[250, 250], [336, 280], [300, 250], 'fluid', [200, 200], [320, 480]],
        },
      },
    },
    kategoriSponTop: {
      name: 'Onedio.com_Mobile_Sponsored_KategoriListeArası_Top',
      sizes: [[336, 280], [300, 250], 'fluid'],
    },
    kategoriSponMiddle: {
      name: 'Onedio.com_Mobile_Sponsored_KategoriListeArası_Middle',
      sizes: [[336, 280], [300, 250], 'fluid'],
    },
    kategoriSponBottom: {
      name: 'Onedio.com_Mobile_Sponsored_KategoriListeArası_Bottom',
      sizes: [[336, 280], [300, 250], 'fluid'],
    },
  },
};
